import { message } from 'antd';
import { action, makeAutoObservable, observable, runInAction } from 'mobx';
import Subjects from '../../models/subjects';
import DictionariesService from '../../services/dictionaries';
import { TaskService, SaveTaskRequest } from '../../services/task-service';
import ImageUploaderStore from '../common/image-uploader';
import SourceFilterStore from '../common/source-filter';
import TagsEditorStore from '../common/tags-editor';
import NumberInKimWithThemeStore from './number-in-kim-with-theme';

export interface CreatedTask {
    source: string,
    theme: string,
    numberInKim: string,
    tags: string,
    answer: string
}

export default class NewTaskStore {

    taskService: TaskService;
    source: SourceFilterStore;
    numberInKimWithTheme: NumberInKimWithThemeStore;
    photoUploader: ImageUploaderStore;
    solutionUploader: ImageUploaderStore;
    dictionariesService: DictionariesService;
    subject: Subjects;

    @observable
    tags: TagsEditorStore;

    @observable
    text: string;

    @observable
    answer: string;

    @observable
    loading: boolean;

    @observable
    step: number;

    @observable
    id: number | null;

    @observable
    savedTask: CreatedTask | null;

    constructor(subject: Subjects) {

        this.taskService = new TaskService();
        this.subject = subject;
        this.source = new SourceFilterStore(subject, false);
        this.numberInKimWithTheme = new NumberInKimWithThemeStore(subject);
        this.tags = new TagsEditorStore();
        this.text = "";
        this.answer = "";
        this.step = 0;
        this.id = null;
        this.savedTask = null;
        this.loading = false;
        this.photoUploader = new ImageUploaderStore(subject, true);
        this.solutionUploader = new ImageUploaderStore(subject, false);
        this.dictionariesService = new DictionariesService();

        makeAutoObservable(this);
    }

    @action
    changeText(value: string): void {
        this.text = value;
    }

    @action
    changeAnswer(value: string): void {
        this.answer = value;
    }

    @action
    changeStep(step: number): void {
        this.step = step;
    }

    @action
    reset(): void {
        this.text = "";
        this.answer = "";
        this.step = 0;
        this.id = null;
        this.savedTask = null;
        this.loading = false;
        this.tags.reset();
        this.source.reset();
        this.numberInKimWithTheme.reset();
        this.photoUploader.reset();
        this.solutionUploader.reset();
    }

    @action
    createTask = async () => {

        this.loading = true;

        try {
            const params: SaveTaskRequest = {
                source: this.source.selectedItemAsNumber,
                numberInKim: this.numberInKimWithTheme.numberInKim.selectedItemAsNumber,
                theme: this.numberInKimWithTheme.theme.selectedItemAsNumber,
                tags: this.tags.getTags,
                answer: this.answer
            };

            this.savedTask = {
                source: this.source.selectedItemValue,
                numberInKim: this.numberInKimWithTheme.numberInKim.selectedItemValue,
                theme: this.numberInKimWithTheme.theme.selectedItemValue,
                tags: this.tags.tagsAsString,
                answer: this.answer
            };

            this.taskService.create(
                this.subject,
                params,
                (data: any) => {

                    if (data && data['id']) {
                        this.id = data['id'];
                        this.photoUploader.setTaskId(data['id']);
                        this.solutionUploader.setTaskId(data['id']);
                    }

                    this.loading = false;
                }, (error: string) => {
                    this.loading = false;
                    message.error(`Ошибка при создании задачи: ${error}`);
                }
            );

        } catch (error) {
            runInAction(() => {
                this.loading = false;
                message.error(`Ошибка при создании задачи: ${error}`);
            });
        }
    }
}